
import { Component, Vue } from 'vue-property-decorator';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import ModalDefault from '@/components/ModalDefault.vue';

@Component({
  components: {
    CameraPageHeader,
    ModalDefault
  }
})
export default class CameraShootTypeConfirmation extends Vue {
  public async created(): Promise<void> {
    // ページマウント時の設定
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }

  public get popupMessage(): string[] {
    return this.$t('202309_482').toString().split('\n') as { [key: number]: string } as string[];
  }

  public useManual(): void {
    this.$store.commit('camera/isDetectStop', true);
    this.pushRoute();
  }

  public keepAuto(): void {
    this.$store.commit('camera/isDetectStop', false);
    this.pushRoute();
  }

  public pushRoute(): void {
    this.$router.push(this.$store.getters['camera/locationIntroduction']);
  }
}
